import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 500,
    margin: "auto",
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamily: "Arial, sans-serif",
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    direction: "rtl",
  },
  lineItem: {
    padding: theme.spacing(1),
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },

  image: {
    width: 100,
    borderRadius: 6,
    float: "left",
    marginLeft: 15,
  },
  scanDialog: {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "36px",
    padding: "6px 12px",
    fontSize: "18px",
    color: "#666",
    zIndex: 1,
  },
  dialogTitle: {
    direction: "rtl",
    padding: "16px 24px",
  },
  dialogTitleBox: {
    position: "relative",
    textAlign: "center",
  },
  userInfoContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    overflow: "hidden",
  },
  
  userDetails: {
    flex: 1,
    textAlign: "right",
    maxWidth: "60%",
  },
  
  imageSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 130,
  },
  
  imageWrapper: {
    width: 130,
    height: 130,
    border: "1px solid #ccc",
    borderRadius: 4,
    backgroundColor: "#fafafa",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  
  webcamContainer: {
    textAlign: "center",
    marginTop: 15,
  },
  
  userImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  },
  
  noImageText: {
    color: "#aaa",
  },
  
  updateImageBtn: {
    marginTop: 12,
    width: "100%",
  },
  
  centeredText: {
    textAlign: "center",
    marginTop: 20,
    color: "#888",
  },
  

}));

export default useStyles;
